module.exports = __webpack_public_path__ + "img/浙江.76599e15.png";